import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class XP44AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleAftCabinLayoutChange = this.handleAftCabinLayoutChange.bind(this);
    }

    handleAftCabinLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.AftCabinLayout = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft Cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard of the Xp 44 is double berth in both aft cabins.' /></p>
                    <p><Trans defaults='Optional is freeboard hung sea berths in both cabins. Please, note that sea berths are not an option if shelves are selected.' /></p>
                    <p><Trans defaults='For extra storage, shelves in both aft cabins is an option.' /></p>
                    
                    <h1><Trans defaults='Options' /></h1>
                    <RadioGroup label={this.props.t("Options:")} options={this.props.AftCabinLayout} value={this.props.configuration.AftCabinLayout} onChange={this.handleAftCabinLayoutChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44AftCabin);


// WEBPACK FOOTER //
// ./src/XP44/XP44AftCabin.js